<div class="multi-dialog-box">
  <div class="fare-container">
    <div class="fare-header">
      <h2> <span>{{ list?.multifares.length || 0 }} FARE OPTIONS</span>  available for your trip.</h2>
      <button (click)="closeDialog()"><mat-icon>close</mat-icon></button>
    </div>
    
    <div class="flight-details" *ngFor="let flight of list?.flightlegs; let i = index">
      <div class="flight-info">
        <img 
          [src]="flight[0]?.carrier | imageUrl" 
          [alt]="flight[0]?.carriername" 
          class="carrier-logo">
        <div class="route">
          <p class="path">{{ flight[0]?.origin_name || flight[0]?.origin }} <mat-icon>trending_flat</mat-icon>
             {{ flight[flight.length - 1]?.destination_name || flight[flight.length - 1]?.destination }}</p> <span class="dot">·</span>
          <p>{{ flight[0]?.depdate | date: 'EEE, d MMM yy' }}</p>  <span class="dot">·</span>
        </div>
      </div>
      <div class="timing">
        <mat-icon>flight_takeoff</mat-icon>&nbsp;<p>Departure: {{ flight[0]?.deptime }}</p>&nbsp; <mat-icon>blur_on</mat-icon> &nbsp;
        <mat-icon>flight_land</mat-icon>&nbsp;<p>Arrival: {{ flight[flight.length - 1]?.arrtime }}</p>
      </div>
    </div>
  </div>
  
    <section class="moreInformationFlight fareInfromationFlight_ d-block">
        <div class="wrapperFlight">
          <ng-container *ngFor="let item_fare of list?.multifares.slice(currentIndex, currentIndex + itemsPerPage); let m = index;"> <!--.slice(currentIndex, currentIndex + itemsPerPage)-->
            <ng-container> <!-- *ngIf="item_fare.faretype[0].name !== 'Unknown'"-->
              <div class="innerWrapper" [class.active]="activeIndex__ === m" (mouseenter)="onMouseEnter(m)" (mouseleave)="onMouseLeave()">
                <div class="flight_deatils_info">
                  <div class="fare_deatils_info">
                    <div class="fare_deatils_info_header">
                      <h3><!--<img src="./assets/svgIcon/fare_checkbox.svg" class="img-fluid">--><span><p><ng-container>{{ item_fare?.faretype?.[0]?.name ? (item_fare?.faretype?.[0]?.name) : 'Fare' }}</ng-container></p></span></h3>
                      <div class="space"></div>
                      <p>{{item_fare.flightfare.totalnet*this.Xchangerates.getCurrency().rate | globalCurrency: this.Xchangerates.getCurrency().shortname}}</p>
                    </div>
                    <div class="fare_deatils_info_body">
                      <ng-container  *ngIf="item_fare.faretype && item_fare.faretype.length > 0"> <!--*ngFor="let list of item_fare['faretype'][0]"-->
                        <div class="fareType__">
                          <!-- <h4>{{ item_fare?.faretype?.[0]?.name ? (item_fare?.faretype?.[0]?.name | titlecase) : 'Fare' }}</h4> -->
                          <!-- <p class="description">{{item_fare.faretype[0].description}}</p> -->
                            <ul>
                              <ng-container *ngFor="let ft of getUniqueFaretypes(item_fare.faretype)">
                                <div class="listWrapper">
                                  <!-- Name only ONCE -->
                                  <h3>{{ ft?.name }}</h3>
                                  <!-- CASE 1: features is ARRAY -->
                                  <ng-container *ngIf="isArray(ft.features)">
                                    <li *ngFor="let point of ft.features">
                                      <mat-icon>check</mat-icon>
                                      <span [innerHTML]="point"></span>
                                    </li>
                                  </ng-container>
                                  <!-- CASE 2: features is OBJECT -->
                                  <ng-container *ngIf="isObject(ft.features)">
                                    <ng-container *ngFor="let key of objectKeys(ft.features)">
                                      <!-- Value is NOT array -->
                                      <li *ngIf="!isArray(ft.features[key])">
                                        <mat-icon>check</mat-icon>
                                        {{ ft.features[key] }}
                                      </li>
                                      <!-- Value is array -->
                                      <li *ngIf="isArray(ft.features[key])" style="flex-wrap: wrap;">
                                        <ul [class]="key">
                                          <li><strong class="w-100">{{ key }}:</strong></li>
                                          <li *ngFor="let value of ft.features[key]">
                                            <mat-icon>check</mat-icon>
                                            <span [innerHTML]="value"></span>
                                          </li>
                                        </ul>
                                      </li>
                                    </ng-container>
                                  </ng-container>
                                </div>
                              </ng-container>
                            </ul>
                        </div>
                      </ng-container>
                    </div>
                  </div>
                </div>
                <div class="fair_footerBooking_button" [ngClass]="{'null-faretype': !item_fare.faretype}">
                  <button mat-button class="bookingButton" color="primary" (click)="submit(list, item_fare)">Book Now</button> <!-- (click)="submit(item, item_fare)" Multifare Button-->
                </div>
              </div>
            </ng-container>
          </ng-container>
          <div *ngIf="isMobile || list.multifares.length > 3" class="pagination-buttons">
            <button class="previousbtn" (click)="previous()" [disabled]="currentIndex === 0"><mat-icon>chevron_left</mat-icon></button>
            <button  (click)="next()" [disabled]="currentIndex + itemsPerPage >= list.multifares.length"><mat-icon>chevron_right</mat-icon></button>
        </div> 
        </div>
      </section>
</div>